export const STORAGE_KEY = 'qasedak-session';

export const state = {
  loader: false,
  session: loadCookieAsJSON(STORAGE_KEY)
};

export const mutations = {

  setSession(state, session) {
    setCookie(STORAGE_KEY, JSON.stringify(session), 1);
    state.session = session;
  },

  lockSession(state, lock) {
    let savedSession = loadCookieAsJSON(STORAGE_KEY);
    savedSession.locked = lock;
    setCookie(STORAGE_KEY, JSON.stringify(savedSession), 1);
    state.session = savedSession;
  },

  closeSession(state) {
    setCookie(STORAGE_KEY, null, 0);
    state.session = null;
  },

  changeLanguage(state, lang) {
    let savedSession = loadCookieAsJSON(STORAGE_KEY);
    savedSession.cultureName = lang;
    setCookie(STORAGE_KEY, JSON.stringify(savedSession), 1);
    state.session = savedSession;
  }
};

function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function loadCookieAsJSON(name) {
  const co = getCookie(name);
  if (co == null)
    return {
      sessionId: 'GUEST',
      language: 'en'
    };

  try {
    return JSON.parse(co || '{}');
  } catch (er) {
    return null;
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      const co = c.substring(name.length, c.length);
      return co;
    }
  }
  return null;
}
